import React from 'react';
import { Observer } from 'mobx-react';
import { Link, Redirect } from 'react-router-dom';
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from '@material-ui/core';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, WideBox } from '../../styles/styles';

// TODO: Complete and find appropriate placement for this component

const AdvancedUser = () => {
  const { orgStore, authStore } = useRootStore();

  return (
    <Observer
      render={() => {
        const { state, orgUserArray, isOwner } = orgStore;
        const { email } = authStore;
        const [owner, setOwner] = React.useState(false);
        const [open, setOpen] = React.useState(false);
        const [value, setValue] = React.useState(-1);

        const handleOpen = () => {
          setOpen(true);
        };

        const handleChange = event => {
          setValue(event.target.value);
        };

        const handleClose = () => {
          setOpen(false);
        };

        const getConfig = async () => {
          await orgStore.retrieveConfig();
        };

        React.useEffect(() => {
          isOwner ? setOwner(true) : setOwner(false);
        }, [getConfig]);

        const transferOwner = async () => {
          try {
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/transfer-owner`,
              {
                userId: value,
              },
            );
            getConfig();
            handleClose();
          } catch (e) {
            console.error(e);
          }
        };
        const filteredUserArray = toJS(orgUserArray).filter(
          user => user.Email !== email,
        );

        if (!state || state === 'error')
          return <Redirect to="/select-organization" />;
        return (
          <FlexDiv>
            <WideBox>
              <Typography variant="h4" paragraph>
                Advanced Settings
              </Typography>
              <List>
                <ListItem button component={Link} to="/roles" divider>
                  <ListItemText
                    primary="Manage Roles"
                    secondary="View, edit, or create roles for this organization"
                  />
                </ListItem>
                {owner && (
                  <ListItem onClick={handleOpen} button divider>
                    <ListItemText
                      primary={
                        <>
                          <div>Transfer Ownership</div>
                        </>
                      }
                      secondary="Relinquish ownership rights of organization to another user"
                    />
                  </ListItem>
                )}
              </List>
              <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogTitle>Relinquish your rights as owner?</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    You are about to give up your rights as owner of this
                    organization. Once confirmed this action is irreversible. If
                    you wish to continue, please select a successor from your
                    organization and click Confirm.
                  </DialogContentText>
                  <FormControl component="fieldset">
                    <RadioGroup value={value} onChange={handleChange}>
                      {filteredUserArray.map(user => {
                        return (
                          <FormControlLabel
                            value={user.UserId}
                            key={user.Email}
                            control={
                              <Radio
                                checked={value === JSON.stringify(user.UserId)}
                              />
                            }
                            label={user.Email}
                          />
                        );
                      })}
                    </RadioGroup>
                  </FormControl>
                </DialogContent>
                <DialogActions>
                  <Button autoFocus onClick={handleClose} color="primary">
                    Cancel
                  </Button>
                  <Button
                    onClick={() => transferOwner()}
                    color="primary"
                    autoFocus
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default AdvancedUser;
